import { render, staticRenderFns } from "./Dependant.vue?vue&type=template&id=78a9923c"
import script from "./Dependant.vue?vue&type=script&lang=js"
export * from "./Dependant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports